<template>
  <div>
    <CCard class="h-100 mx-auto" style="max-width: 500px;">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="">
              <h5 class="text-left mt-4 d-flex d-sm-none text-black bold">
                Teacher Professional Profile
              </h5>
              <CRow>
                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-1 mt-1"
                >
                  <div class="text-center custom-width-lg p-0 mb-3">
                    <CRow class="justify-content-center p-0 mt-2">
                      <CCol sm="12" lg="12">
                        <CRow>
                          <CCol sm="12" lg="12">
                            <div class="mt-3 mb-4 text-left"></div>
                            <CTextarea
                              filled
                              auto-grow
                              rows="10"
                              row-height="30"
                              shaped
                              class="mt-2"
                              v-model="ProfessionalName"
                              placeholder="Enter Professional Profile"
                            />
                          </CCol>
                        </CRow>
                        <div class="mt-4">
                          <CButton
                            color="info"
                            class="custom-btn ml-2 mr-2 mb-2"
                            @click="SaveResume"
                            block
                            >Update</CButton
                          >
                        </div>
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>     
<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import backgroundBanner from "../assets/img/bgApps.jpg";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);
import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

export default {
  name: "Login",
  components: {
    PulseLoader
  },
  data() {
    return {
      backgroundUrl,
      backgroundBanner,
      ProfessionalName: "",
      teacherProfessional: {}
    };
  },
  async mounted() {
    await this.GetProfessionalProfile();
  },

  methods: {
    async GetProfessionalProfile() {
      this.$API
        .get(
          this.$TeacherProfessional + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.teacherProfessional = response.data;
            this.ProfessionalName = this.teacherProfessional.Content;
          } else {
            this.teacherProfessional = null;
            this.ProfessionalName = "none";
          }
        });
    },
    SaveResume() {
      this.UpdateProfessionalProfile();
    },
    UpdateProfessionalProfile() {
      const formData = new FormData();
      formData.append("userId", this.$route.query.userId);
      formData.append("content", this.ProfessionalName);

      return this.$API
        .post(this.$InsertUpdateProfessionalProfile, formData, {
          withCredentials: true
        })
        .then(response => {
          this.GoToPreviousPage();
          if (response.status == 200 && response.data != null) {
            this.$dialog
              .alert("You have successfully save the professional profile")
              .then(function(dialog) {
                console.log("Closed");
              });
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
    GoToPreviousPage() {
      this.$router.push("/QuizTeacherProfile?userId=" + this.$route.query.userId);
    }
  }
};
</script>

#fb-root{
  display:none;
}